import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap";

@Component({
  selector: 'app-transport',
  templateUrl: './transport.component.html',
  styleUrls: ['./transport.component.scss']
})
export class TransportComponent implements OnInit {
  trans: any;
  img: any;
  isLoading: any;
  transForm: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("lgModal", {static: true}) lgModal;
  dltID: any;
  isupdate: boolean;
  updateId: any;
  removeEvt: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifierService: NotifierService,
              private userService: UserService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.getAllTransport();
    this.transForm = this.formBuilder.group({
      name: ["", [Validators.required]],
      description: ["", [Validators.required]],
    });
    this.isupdate =false;
  }

  view( view,id) {
    view.show();
    this.userService.getTransportImg(id).subscribe(
      res=>{
        if(res.responseCode==200){
          this.img =res.data;
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }

  openModal(errorModal, id: any) {
    this.dltID=id;
    this.modalRef = this.modalService.show(errorModal, {class: 'modal-dialog-centered'});
  }

  declineCancel() {
    this.modalRef.hide();
  }

  confirmCancel() {

    this.userService.deleteTransport(this.dltID).subscribe(
      res=>{
        if(res.responseCode==200){
          this.modalRef.hide();
          this.getAllTransport();
          this.notifierService.notify('success',  res.responseDesc);
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }

  update(gal: any) {
    // this.previewUrl =gal.image;
    this.lgModal.show();
    this.updateId =gal.id;
    this.isupdate =true;
    this.transForm.controls['name'].setValue(gal.name);
    this.transForm.controls['description'].setValue(gal.description);
  }



  getAllTransport(){
    this.userService.getAllTransport().subscribe(
      res=>{
        if(res.responseCode==200){
          this.trans =res.data;
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }

  createTrasport(){
    let req={
      name:this.transForm.controls.name.value,
      description:this.transForm.controls.description.value,
    }
    this.userService.createTransport(req).subscribe(
      res=>{
        if(res.responseCode==200){
          this.getAllTransport();
          this.lgModal.hide();
          this.upload(res.data)
          localStorage.setItem('imgID',res.data);
          this.notifierService.notify('success',  res.responseDesc);
          this.onRemove(this.removeEvt);
          this.transForm.reset();
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }

  updateTransport(){
    let req={
      id:this.updateId,
      name:this.transForm.controls.name.value,
      description:this.transForm.controls.description.value,
    }
    this.userService.createTransport(req).subscribe(
      res=>{
        if(res.responseCode==200){
          this.getAllTransport();
          this.lgModal.hide();
          this.upload(res.data);
          this.onRemove(this.removeEvt);
          this.transForm.reset();
          this.notifierService.notify('success',  res.responseDesc);
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }

  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;


  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    }
  }


  addModal(lgModal) {
    this.isupdate=false;
    lgModal.show();
  }

  upload(id) {
    this.userService.transportImgUpload(this.files[0], id).subscribe(
      data => {
        if (data.responseCode == 200) {
          this.notifierService.notify('success', data.responseDesc);
        } else {
          this.notifierService.notify('danger', 'Somthing went wrong faild to upload image.');
        }
      });
  }

  files: File[] = [];
  itForm: any;

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.removeEvt=event
    this.files.splice(this.files.indexOf(event), 1);
  }
}
